/**
 * Reine Helfer für die persistente Server-Auswahl (localStorage). DOM-/signal-frei,
 * damit testbar. Der eigentliche localStorage-Zugriff liegt im Store (browser-only).
 */

/** localStorage-Key für den zuletzt aktiven Server (stabile Server-ID). */
export const ACTIVE_SERVER_KEY = "bf2142.activeServer";

/**
 * Welcher Server soll aktiv sein?
 * 1. `current`, falls noch in der Liste (laufende Auswahl nie ungefragt wegreißen),
 * 2. sonst `stored` (zuletzt gewählt), falls noch vorhanden — der Reload-Fall,
 * 3. sonst der erste verfügbare Server,
 * 4. sonst `null` (keine Server).
 * Gespeicherte IDs, die es nicht mehr gibt, fallen sauber auf den ersten zurück.
 */
export function resolveActiveServer(
  serverIds: readonly string[],
  stored: string | null | undefined,
  current: string | null | undefined,
): string | null {
  if (current && serverIds.includes(current)) return current;
  if (stored && serverIds.includes(stored)) return stored;
  return serverIds[0] ?? null;
}
